export function TrustBar() {
  const items = [
    { icon: 'ri-star-fill', value: '5.0 Stars', label: '500+ Google Reviews', gold: true },
    { icon: 'ri-shield-check-line', value: 'Licensed & Insured', label: 'Florida Certified', gold: false },
    { icon: 'ri-medal-line', value: '3M Certified', label: 'Authorized Dealer', gold: false },
    { icon: 'ri-time-line', value: 'Same-Day Service', label: 'Available Mon–Sat', gold: false },
    { icon: 'ri-tools-line', value: '15+ Years', label: 'Expert Experience', gold: false },
  ];

  return (
    <div className="bg-[#0D0D0D] border-y border-white/5">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex flex-wrap items-center justify-between gap-y-4 py-5">
          {items.map((item, i) => (
            <div key={i} className="flex items-center gap-3 pr-6 last:pr-0">
              <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                <i className={`${item.icon} text-xl`} style={{ color: item.gold ? '#C9A96E' : '#FF6B35' }} />
              </div>
              <div>
                <div
                  className="text-white text-sm font-bold leading-none mb-0.5"
                  style={{ fontFamily: 'Sora, sans-serif' }}
                >
                  {item.value}
                </div>
                <div className="text-white/40 text-xs">{item.label}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
